<template>
  <svg class="icon-podium" :class="color" viewBox="0 0 36 36">
    <path
      class="icon-podium"
      d="M0,21.014l5.333-0.464L4.95,25.964l4.95-0.707l-0.707,4.95l5.4-0.396l-0.479,5.318l15.339-15.339    L15.339,5.675L0,21.014z M21.029,14.07l-1.62,4.898l3.141,4.187l-5.188-0.115l-2.956,4.208l-1.586-4.969l-4.968-1.586l4.208-2.956    l-0.115-5.188l4.187,3.141L21.029,14.07z M31.562,10.585c0,0-2.796,1.447-5.635-1.392c-2.828-2.828-1.458-5.701-1.458-5.701    L20.978,0l-4.243,4.243l14.142,14.142l4.243-4.243L31.562,10.585z"
    />
  </svg>
</template>

<script setup lang="ts">
defineProps<{ color?: string }>()
</script>

<style lang="less" scoped>
@import '~@npm/@gd/common-styles/lib/color-vars';
.icon-podium {
  width: 1.5em;
  height: 1.5em;
  fill: #f49906;
}
.highlighted {
  .icon-podium {
    fill: white;
  }
}
</style>
